.eds-resizable-layout--indicator {
  --_overlay: none;

  align-items: center;
  background-color: var(--eds--color--bg-base);
  background-image: var(--_overlay);
  border: var(--eds--size-1) solid var(--eds--color--border-default);
  border-radius: var(--eds--radii-full);
  box-sizing: border-box;
  color: var(--eds--color--fg-hint);
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  left: 50%;
  pointer-events: none;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
}

.eds-resizable-layout--indicator--vertical {
  height: var(--eds--size-40);
  width: var(--eds--size-16);
}

.eds-resizable-layout--indicator--horizontal {
  height: var(--eds--size-16);
  width: var(--eds--size-40);
}

.eds-resizable-layout--glyph {
  display: flex;
}

.eds-resizable-layout--glyph--horizontal {
  transform: rotate(90deg);
}

.eds-resizable-layout--indicator--hidden {
  display: none;
}

.eds-resizable-layout--handle:hover .eds-resizable-layout--indicator {
  --_overlay: linear-gradient(
    var(--eds--overlay-hover-default),
    var(--eds--overlay-hover-default)
  );
}

.eds-resizable-layout--handle--active .eds-resizable-layout--indicator {
  --_overlay: linear-gradient(
    var(--eds--overlay-pressed-default),
    var(--eds--overlay-pressed-default)
  );
  border-color: var(--eds--color--border-brand);
  color: var(--eds--color--border-brand);
}

.eds-resizable-layout--handle:focus-visible
  .eds-resizable-layout--indicator:not(
    .eds-resizable-layout--indicator--hidden
  ) {
  --_overlay: linear-gradient(
    var(--eds--overlay-pressed-default),
    var(--eds--overlay-pressed-default)
  );
  box-shadow: var(--eds--interaction-focus-ring);
}

.eds-resizable-layout--handle:focus-visible {
  outline: none;
}
